import { render, staticRenderFns } from "./createEsgStandard.vue?vue&type=template&id=f0e518b2&scoped=true"
import script from "./createEsgStandard.vue?vue&type=script&lang=js"
export * from "./createEsgStandard.vue?vue&type=script&lang=js"
import style0 from "./createEsgStandard.vue?vue&type=style&index=0&id=f0e518b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e518b2",
  null
  
)

export default component.exports